import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_DATAENTRY_BY_ID,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_FAILURE,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_DATAENTRY,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_FAILURE,

    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_FAILURE,

    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CLEAR,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_FILTER,


    TrialInstitutionItemCustomViewAction
} from '../actions/trialInstitutionItemCustomView';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionItemCustomViewState {
    formData: Dtos.TrialInstitutionItemCustomView | Dtos.TrialInstitutionItemCustomView[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionItemCustomView[];
    formLength: number;
}

const initialState: ITrialInstitutionItemCustomViewState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};

function loading(state: ITrialInstitutionItemCustomViewState, _isLoading: boolean): ITrialInstitutionItemCustomViewState {
    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialInstitutionItemCustomViewState,
    formData: Dtos.TrialInstitutionItemCustomView | Dtos.TrialInstitutionItemCustomView[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemCustomViewState {
    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialInstitutionItemCustomViewState, formFilter: IFormFilter): ITrialInstitutionItemCustomViewState {

    const items: Dtos.TrialInstitutionItemCustomView[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (
            formFilter.search == "" ||
            p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1
        )) : undefined;

    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function loadFailure(state: ITrialInstitutionItemCustomViewState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemCustomViewState {
    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionItemCustomViewState, propertiesToClear?: string[]): ITrialInstitutionItemCustomViewState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionItemCustomViewState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialInstitutionItemCustomViewState, _isSaving: boolean): ITrialInstitutionItemCustomViewState {
    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionItemCustomViewState,
    formData: Dtos.TrialInstitutionItemCustomView,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemCustomViewState {
    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionItemCustomViewState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemCustomViewState {
    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionItemCustomViewState, isCreating: boolean): ITrialInstitutionItemCustomViewState {
    const status = isCreating ? RequestState.Pending : RequestState.Success;
    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        createState: {
            $set: {
                status: status
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionItemCustomViewState,
    formData: Dtos.TrialInstitutionItemCustomView,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionItemCustomViewState {
    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionItemCustomViewState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemCustomViewState {
    const newState: ITrialInstitutionItemCustomViewState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}


const TrialInstitutionItemCustomViewReducer: Reducer<ITrialInstitutionItemCustomViewState> = (state: ITrialInstitutionItemCustomViewState = initialState, action: TrialInstitutionItemCustomViewAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD:
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_BY_ID:
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_DATAENTRY_BY_ID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE:
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_DATAENTRY:
            return saving(state, true);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default TrialInstitutionItemCustomViewReducer;